import React from "react";

const NotificationsSenior = (props) => {
  return (
    <svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.59911 16.813C1.33221 16.813 1.09255 16.6605 0.983618 16.4208C0.874682 16.1812 0.91281 15.8979 1.08166 15.6964C2.53595 13.9861 3.29306 11.4969 3.33663 8.31056C3.33663 4.8573 6.33781 2.07944 10.0253 2.07944C14.0559 2.07944 16.6595 4.53049 16.6595 8.31601C16.6595 11.802 17.8251 14.411 18.9144 15.6964C19.0887 15.8979 19.1269 16.1812 19.0125 16.4208C18.8981 16.6605 18.6584 16.813 18.397 16.813H1.59911ZM2.92812 15.4513H17.0843C16.1257 13.8227 15.2978 11.3499 15.2978 8.31056C15.2978 4.71568 12.5744 3.43569 10.0253 3.43569C7.08947 3.43569 4.69833 5.60351 4.69833 8.26154V8.32146C4.6602 11.2137 4.0665 13.6048 2.93357 15.4513H2.92812Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.3"
      />
      <path
        d="M10.0203 20.5C11.5018 20.5 12.6838 19.4161 12.6838 18.0217H7.31323C7.31323 19.4161 8.49519 20.5 10.0203 20.5Z"
        fill={props.color}
      />
      <path
        d="M11.3271 2.75497V1.74187C11.3271 1.08281 10.7334 0.5 10.0144 0.5C9.25183 0.5 8.66357 1.08281 8.66357 1.74187V2.75497H11.3271Z"
        fill={props.color}
      />
    </svg>
  );
};

export default NotificationsSenior;
